import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import GardenVision from './pages/GardenVision';
import Conservancy from './pages/Conservancy';
import GardenDevelopment from './pages/GardenDevelopment';
import WaysToGive from './pages/WaysToGive';
import Programs from './pages/Programs';
import News from './pages/News';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import { Toaster } from './components/ui/toaster';
import { AuthProvider, useAuth } from './context/AuthContext';

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100); return; }
    }
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-cream text-forest">Loading…</div>;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
};

// Public site chrome (navbar + footer). Admin routes render without it.
const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollManager />
          <Routes>
            {/* Admin (no public chrome) */}
            <Route path="/admin" element={<Login />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

            {/* Public site */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/vision" element={<PublicLayout><GardenVision /></PublicLayout>} />
            <Route path="/conservancy" element={<PublicLayout><Conservancy /></PublicLayout>} />
            <Route path="/development" element={<PublicLayout><GardenDevelopment /></PublicLayout>} />
            <Route path="/give" element={<PublicLayout><WaysToGive /></PublicLayout>} />
            <Route path="/programs" element={<PublicLayout><Programs /></PublicLayout>} />
            <Route path="/news" element={<PublicLayout><News /></PublicLayout>} />
            <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
